import * as yup from 'yup'

const companyTypeOptions = [
    {
        label: 'חברה ציבורית',
        value: 'Public_Company',
    },
    {
        label: 'חברה פרטית',
        value: 'Private_Company',
    },
    {
        label: 'עוסק מורשה',
        value: 'Authorized_Contractor',
    },
    {
        label: 'עוסק פטור',
        value: 'Exempt_Contractor',
    },
    {
        label: 'ארגון ללא מטרות רווח',
        value: 'Non_Profit_Organization',
    },
]

const reportingPeriodTypeOptions = [
    {
        label: 'אחת לחודש',
        value: 'OnceInAMonth',
    },
    {
        label: 'אחת לחודשיים',
        value: 'OnceInTwoMonths',
    },
]

const schema = yup.object({
    companyName: yup
        .string()
        .label('שם החברה')
        .required('נא להזין שם החברה')
        .meta({
            section: 'basic',
        }),
    totalEntries: yup
        .number()
        .label('סה״כ רשומות'),
    invalidEntries: yup
        .number()
        .label('לא תקינות'),
    companyId: yup
        .string()
        .label('ח״פ/ע״מ/ת״ז')
        .required('נא להזין מזהה חברה')
        .meta({
            section: 'basic',
        }),
    companyType: yup
        .string()
        .label('סוג החברה')
        .nullable()
        .transform((value) => (value === '' ? undefined : value))
        .meta({
            section: 'taxes',
            options: companyTypeOptions,
        })
        .oneOf(companyTypeOptions.map((option) => option.value)),
    reportingPeriodType: yup
        .string()
        .label('תקופת הדיווח')
        .nullable()
        .transform((value) => (value === '' ? undefined : value))
        .meta({
            section: 'taxes',
            options: reportingPeriodTypeOptions,
        })
        .oneOf(reportingPeriodTypeOptions.map((option) => option.value)),
})

export default schema
